import {Avatar} from "../../__snowpack__/pkg/antd.js";
import React from "../../__snowpack__/pkg/react.js";
import {platformLogo} from "../lib/basic.js";
export const TableStoreLogo = (props) => {
  const {channelName} = props;
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Avatar, {
    size: props.size ? props.size : 32,
    src: platformLogo(channelName, true),
    style: {
      marginRight: props.size ? 5 : 10,
      width: props.size || 32,
      minWidth: props.size || 32,
      maxWidth: props.size || 32
    }
  }));
};
